

















import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'RecapEditor'

  vue:
    props: ['recap']

    components: {
      FormField,
    }

    data: ->
      data: @recap

    methods:
      displayQuestion: (question) ->
        RecapUtility.displayQuestion question, @data.answers

    watch:
      recap: (value) ->
        @data = value

export default VueOptions.vue settings
